import GoogleMapsAutocomplete from "Constants/campaign/maps/googleMapsAutocomplete";

export default class FieldsOption {
  constructor() {
    const isEnabled = window.P2A.GOOGLE_MAPS_EMBED ? window.P2A.GOOGLE_MAPS_EMBED.isAutocompleteGeocodeEnabled : false;

    let fields = [GoogleMapsAutocomplete.GOOGLE_MAPS_FIELD_ADDRESS_COMPONENT];

    if (isEnabled) {
      fields.push(GoogleMapsAutocomplete.GOOGLE_MAPS_FIELD_GEOMETRY)
    }

    return fields;
  }
}
